import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import { environment } from '@environment';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';

@Component({
  selector: 'app-info-contact-company',
  templateUrl: './info-contact-company.component.html',
  styleUrls: ['./info-contact-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoContactCompanyComponent {
  @Output() eventTracker = new EventEmitter<string>();

  srcLogoLaBonneAlternance = `${environment.wizbiiImages}/la_bonne_alternance/la_bonne_alternance.png`;
  srcLogoLaBonneBoite = `${environment.wizbiiImages}/la_bonne_boite/la_bonne_boite.png`;
  srcLogoYouzful = `${environment.wizbiiImages}/casa/youzful_logo.png`;

  urlLaBonneBoite = 'https://labonneboite.pole-emploi.fr/';
  urlLaBonneAlternance = 'https://labonnealternance.pole-emploi.fr/';
  urlYouzful =
    'https://www.youzful-by-ca.fr/pro/annuaire?at_medium=affiliate&at_campaign=906&at_type=Direct&at_identifier=1_jeune_1_solution&at_format=Footer&at_creation=PageEmploi';
}

@NgModule({
  imports: [CommonModule, ImaginarySrcModule, ExternalLinkDirectiveModule],
  declarations: [InfoContactCompanyComponent],
  exports: [InfoContactCompanyComponent],
})
export class InfoContactCompanyModule {}
